import styled from "styled-components";

export const CtgListTable = styled.table`
  width: 100%;
  background-color: ${({ theme }) => theme.color.neural.gray00};
  margin-top: 2.4rem;
  min-width: 140rem;
`;
